"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtendedBaseDebug = exports.extendDebug = exports.baseDebug = void 0;
const tslib_1 = require("tslib");
const debug_1 = tslib_1.__importDefault(require("debug"));
exports.baseDebug = {
    log: debug_1.default("log"),
    wrn: debug_1.default("wrn"),
    vrbs: debug_1.default("vrbs"),
    reThrown: debug_1.default("reThrown"),
    err: debug_1.default("error"),
};
function extendDebug(toExtend) {
    return function (key) {
        return {
            log: toExtend.log.extend(key),
            wrn: toExtend.wrn.extend(key),
            vrbs: toExtend.vrbs.extend(key),
            reThrown: toExtend.reThrown.extend(key),
            err: toExtend.err ? toExtend.err.extend(key) : exports.baseDebug.err.extend(key),
        };
    };
}
exports.extendDebug = extendDebug;
exports.getExtendedBaseDebug = extendDebug(exports.baseDebug);
//# sourceMappingURL=debuggers.js.map